import React, { useState } from 'react'
import { connect } from 'react-redux'
import styles from './styles.scss';
import { handleOnChange } from '../../customActions';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';

export const RangeboxContainer = (props) => {

    const {
        item,
        parentIndex,
        handleOnChange,
        isSellOnline
    } = props;

    const {
        s_id,
        s_dnm,
        userInput,
        s_mandatory,
        s_re_mandatory,
        s_nm
    } = item;

    const [focus, setFocus] = useState(false);

    const inputFields = [
        {
            label: "",
            input:{
                value: userInput.value,
                type: 'text',
                name: s_nm,
                autoFocus: false,
                onChange: (e) => handleOnChange({e, parentIndex, item,isSellOnline}),
                onFocus: () => setFocus(true),
                onBlur:() => setFocus(false),
                autoComplete: "off",
                readOnly: (props?.isEnrichSpec && userInput.value) ? true : false
            },
            errorMessage: userInput.error,
            infoMessage:!userInput.error && (props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.session.viaOmni && !props.isAuditor ? 'Required Field':''
        } ,
        {
            label: "",
            input:{
                value: userInput.textboxValue,
                type: 'text',
                name: s_nm,
                autoFocus: false,
                autoComplete: "off",
                onFocus: () => setFocus(true),
                onBlur:() => setFocus(false),
                onChange: (e) => handleOnChange({e, parentIndex, item, key: "textboxValue",isSellOnline}),
                readOnly: (props?.isEnrichSpec && userInput.textboxValue) ? true : false

            },
            errorMessage: userInput.textboxError,
            infoMessage:!userInput.error && (props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.session.viaOmni && !props.isAuditor ? 'Required Field':''
        }
    ]

    return (
        <div className={`${styles["rangebox-wrapper"]} ${styles["rangebox-container"]} ${focus ? styles["label-focus"] : ""} ${(userInput.error || userInput.textboxError) ? styles["label-error"] : ""}`}>
            <div className={styles["rangebox-label"]}>{ s_dnm }</div>
            <div className={styles["rangebox-input-container"]}>
                {
                    inputFields.map((input, index) => {
                        return <InputWithMovingLabel key={`${s_id}-${index}`} {...input} />
                    })
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        isSellOnline: state.products.editProduct.isSellOnline || props.showSellOnline,
        session: state.session,
        isService: state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleOnChange: (payload) => dispatch(handleOnChange(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RangeboxContainer)
